<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(roles.admins)">
      <admin />
    </div>
  </div>
</template>
<script>

import roles from './../roles.js'
import admin from './components/admin.vue'

export default {
  components: {
    admin
  },
  data() {
    return {
      roles
    }
  }
};
</script>